// import { Toolbar, Typography, IconButton, Box } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { AddButton } from "../button/AddButton";
// import { useLocation, useNavigate } from "react-router-dom";
// import AddDocument from "../Modal/AddDocument";
// import { useState } from "react";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Toolbar, Typography, IconButton, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AddButton } from "../button/AddButton";
import AddDocument from "../Modal/AddDocument";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { resetSingleProduzione } from "../../features/produzioni/produzioniSlice";
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// const HeaderBelow = ({ cantine, setCantine, production, setProduction }) => {
//   const navigate = useNavigate();
//   const [open, setOpen] = useState(false);

  const routeMap = [
    {
      match: "/strutture/cantine/Terreni",
      title: "Cantina",
      backTo: "/strutture/cantine",
    },
    {
      match: "/strutture/cantine/Stabilimenti",
      title: "Cantina",
      backTo: "/strutture/cantine",
    },
    {
      match: "/strutture/cantine/Prodotti",
      title: "Cantina",
      backTo: "/strutture/cantine",
    },
    {
      match: "/strutture/cantine/Mezzi",
      title: "Cantina",
      backTo: "/strutture/cantine",
    },
    {
      match: "/strutture/cantine",
      title: "Cantine",
      backTo: "/dashboard",
    },
    {
      match: "/strutture/terreni/Particelle",
      title: "Terreni",
      backTo: "/strutture/terreni",
    },
    {
      match: "/strutture/terreni/Sensori",
      title: "Terreni",
      backTo: "/strutture/terreni",
    },
    {
      match: "/strutture/terreni/Trattamenti",
      title: "Terreni",
      backTo: "/strutture/terreni",
    },
    {
      match: "/strutture/operatori",
      title: "Operatori",
      backTo: "/dashboard",
    },
    {
      match: "/produzione/archivio",
      title: "Archivio Produzioni",
      backTo: "/dashboard",
    },
    {
      match: "/produzione/trattamenti",
      title: "Trattamenti",
      backTo: "/dashboard",
    },
    {
      match: "/produzione/ricette/Fasi",
      title: "Ricette",
      backTo: "/dashboard",
    },
    {
      match: "/produzione/ricette/Statistiche",
      title: "Ricette",
      backTo: "/dashboard",
    },
    {
      match: "/produzione/ricette/Dati",
      title: "Ricette",
      backTo: "/dashboard",
    },
    {
      match: "/produzione/vendemmia",
      title: "Produzioni",
      backTo: "/produzione/produzioni",
    },
    {
      match: "/produzione/produzioni",
      title: "Produzioni",
      backTo: "/dashboard",
    },
    {
      match: "/strutture/prodotti/Giacenze",
      title: "Prodotti",
      backTo: "/strutture/prodotti",
    },
    {
      match: "/strutture/sensori/Location",
      title: "Sensori",
      backTo: "/strutture/sensori",
    },
    {
      match: "/strutture/sensori/Location/Oggi",
      title: "Sensori",
      backTo: "/strutture/sensori",
    },
    {
      match: "/strutture/sensori/Location/ultima_settimana",
      title: "Sensori",
      backTo: "/strutture/sensori",
    },
    {
      match: "/strutture/sensori/Location/ultimo_mese",
      title: "Sensori",
      backTo: "/strutture/sensori",
    },
    {
      match: "/strutture/sensori/Location/Archivio",
      title: "Sensori",
      backTo: "/strutture/sensori",
    },
    {
      match: "/strutture/sensori",
      title: "Sensori",
      backTo: "/dashboard",
    },
    
    {
      match: "/strutture/prodotti",
      title: "Prodotti",
      backTo: "/dashboard",
    },
    {
      match: "/logistica/trasporto",
      title: "Trasporti",
      backTo: "/dashboard",
    },
    {
      match: "/logistica/trasporto/graph",
      title: "Trasporti",
      backTo: "/logistica/trasporto",
    },
    {
      match: "/logistica/mezzi",
      title: "Mezzi",
      backTo: "/dashboard",
    },
    {
      match: "/logistica/mezzi/Manutenzione",
      title: "Mezzi",
      backTo: "/logistica/mezzi",
    },
    {
      match: "/logistica/mezzi/Documenti",
      title: "Mezzi",
      backTo: "/logistica/mezzi",
    },
    {
      match: "/logistica/mezzi/Sensori",
      title: "Mezzi",
      backTo: "/logistica/mezzi",
    },
    {
      match: "/logistica/mezzi/Viaggi",
      title: "Mezzi",
      backTo: "/logistica/mezzi",
    },
    {
      match: "/logistica/stabilimenti/Attrezzature",
      title: "Stabilimenti",
      backTo: "/logistica/stabilimenti",
    },
    {
      match: "/logistica/stabilimenti/Sensori",
      title: "Stabilimenti",
      backTo: "/logistica/stabilimenti",
    },
    {
      match: "/logistica/stabilimenti/Giacenze",
      title: "Stabilimenti",
      backTo: "/logistica/stabilimenti",
    },
    {
      match: "/logistica/stabilimenti",
      title: "Stabilimenti",
      backTo: "/dashboard",
    },
    {
      match: "/strutture/stabiliment/Attrezzature",
      title: "Stabilimenti",
      backTo: "/strutture/stabilimenti",
    },
    {
      match: "/strutture/stabiliment/Sensori",
      title: "Stabilimenti",
      backTo: "/strutture/stabilimenti",
    },
    {
      match: "/strutture/stabiliment/Giacenze",
      title: "Stabilimenti",
      backTo: "/strutture/stabilimenti",
    },
    {
      match: "/strutture/stabilimenti",
      title: "Stabilimenti",
      backTo: "/dashboard",
    },  
    {
      match: "/strutture/terreni",
      title: "Terreni",
      backTo: "/dashboard",
    },
    {
      match: "/invoice",
      title: "Categoria",
      backTo: "/dashboard/profitti",
    },
    {
      match: "/gantt",
      title: "Attività",
      backTo: "/dashboard/profitti",
    },
    {
      match: "/gantt/library",
      title: "Attività",
      backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/calendario",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/preventivi/sub-preventivi",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/preventivi",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/ordini/sub-ordini",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/ordini",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/budget/",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/budget",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/lead",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/vendite/sub-lead/",
      title: "Vendite",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/fornitori/",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/fornitori",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/calendario",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/preventivi/sub-preventivi",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/preventivi",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/ordini/sub-ordini",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/ordini",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/budget/sub-budget",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/acquisti/budget",
      title: "Acquisti",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/profitti",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/acquisti",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/asset",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/imposte",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/produzione",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/vendite",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/personale",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/dashboard/attivita",
      title: "Ovoland",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/cataloghi/servizi/",
      title: "Cataloghi",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/cataloghi/servizi",
      title: "Cataloghi",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/cataloghi/prodotti/",
      title: "Cataloghi",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/cataloghi/prodotti",
      title: "Cataloghi",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/cataloghi/configuratore/",
      title: "Cataloghi",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/cataloghi/listini/",
      title: "Cataloghi",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/cataloghi/listini",
      title: "Cataloghi",
      // backTo: "/dashboard/profitti",
    },
    {
      match: "/hr/sub-colaboratory/",
      title: "HR",
      // backTo: "/dashboard/profitti",
    },
  { match: "/hr/colaboratory", title: "Collaboratori", backTo: "/hr" },
  { match: "/hr/Calendario", title: "Turni", backTo: "/hr" },
  { match: "/hr/organizza/", title: "Nome del turno", backTo: "/hr/Organizza" },
  { match: "/hr/Organizza", title: "Turni", backTo: "/hr" },
  { match: "/hr/ferie-e-permisse/evento", title: "Nome evento", backTo: "/hr/ferie-e-permisse" },
  { match: "/hr/ferie-e-permisse", title: "Eventi", backTo: "/hr" },
  { match: "/hr/buste-page/busta", title: "Nome della busta paga", backTo: "/hr/buste-page" },
  { match: "/hr/buste-page", title: "Busta paga", backTo: "/hr" },
  { match: "/hr/candidati/candidato/", title: "Candidato", backTo: "/hr/candidati" },
  { match: "/hr/candidati", title: "Candidati", backTo: "/hr" },

  // Amministrazione
  { match: "/amministrazione/imposte/", title: "Nome dell’imposta", backTo: "/amministrazione/imposte" },
  { match: "/amministrazione/imposte", title: "Imposte", backTo: "/amministrazione" },
  { match: "/amministrazione/documenti/", title: "Fattura", backTo: "/amministrazione/documenti" },
  { match: "/amministrazione/documenti", title: "Documenti", backTo: "/amministrazione" },
  { match: "/amministrazione/bilancio", title: "Bilancio", backTo: "/amministrazione" },
  { match: "/amministrazione/scadenzario", title: "Scadenzario", backTo: "/amministrazione" },
  { match: "/amministrazione/asset/", title: "Nome asset", backTo: "/amministrazione/asset" },
  { match: "/amministrazione/asset", title: "Asset", backTo: "/amministrazione" },
  { match: "/amministrazione/flussi-di-cassa", title: "Flusso di cassa", backTo: "/amministrazione" },
  { match: "/amministrazione/registri-iva", title: "Registri IVA", backTo: "/amministrazione" },
  { match: "/amministrazione/prima-nota", title: "Prima nota", backTo: "/amministrazione" },
    // Logistica routes
    {
      match: "/logistica/prenota",
      title: "Prenota",
      backTo: "/logistica",
      parent: "Logistica"
    },
    {
      match: "/logistica/stabilimenti/",
      title: "Nome stabilimento",
      backTo: "/logistica/stabilimenti",
      parent: "Stabilimenti"
    },
    {
      match: "/logistica/stabilimenti",
      title: "Stabilimenti",
      backTo: "/logistica",
      parent: "Logistica"
    },
    {
      match: "/logistica/mezzi/",
      title: "Nome del mezzo",
      backTo: "/logistica/mezzi",
      parent: "Mezzi"
    },
    {
      match: "/logistica/mezzi",
      title: "Mezzi",
      backTo: "/logistica",
      parent: "Logistica"
    },
    {
      match: "/logistica/attrezzature/",
      title: "Nome dell'attrezzatura",
      backTo: "/logistica/attrezzature",
      parent: "Attrezzature"
    },
    {
      match: "/logistica/attrezzature",
      title: "Attrezzature",
      backTo: "/logistica",
      parent: "Logistica"
    },
    {
      match: "/logistica/giacenze/",
      title: "Nome della giacenza",
      backTo: "/logistica/giacenze",
      parent: "Giacenze"
    },
    {
      match: "/logistica/giacenze",
      title: "Giacenze",
      backTo: "/logistica",
      parent: "Logistica"
    },
    {
      match: "/logistica/sub-DDT",
      title: "Numero del DDT",
      backTo: "/logistica/DDT",
      parent: "DTT"
    },
    {
      match: "/logistica/DDT",
      title: "DTT",
      backTo: "/logistica",
      parent: "Logistica"
    },
  
    // Anagrafiche routes
    {
      match: "/anagrafiche/sub-lead/",
      title: "Nome del lead",
      backTo: "/angrafiche/lead",
      parent: "Lead"
    },
    {
      match: "/angrafiche/lead",
      title: "Lead",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/prodotti",
      title: "Prodotti",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/attrezzature",
      title: "Attrezzature",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/mezzi",
      title: "Mezzi",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/sensori",
      title: "Sensori",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/stabilimenti",
      title: "Stabilimenti",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/lotti",
      title: "Lotti",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/clienti/",
      title: "Nome del cliente",
      backTo: "/angrafiche/clienti",
      parent: "Clienti"
    },
    {
      match: "/angrafiche/clienti",
      title: "Clienti",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/fornitori/",
      title: "Nome del Fornitore",
      backTo: "/angrafiche/fornitori",
      parent: "Fornitori"
    },
    {
      match: "/angrafiche/fornitori",
      title: "Fornitori",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/sub-colaboratory/",
      title: "Nome del collaboratore",
      backTo: "/angrafiche/colaboratory",
      parent: "Collaboratori"
    },
    {
      match: "/angrafiche/colaboratory",
      title: "Collaboratori",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
    {
      match: "/angrafiche/candidati/",
      title: "Nome del collaboratore",
      backTo: "/angrafiche/candidati",
      parent: "Collaboratori"
    },
    {
      match: "/angrafiche/candidati",
      title: "Collaboratori",
      backTo: "/anagrafiche",
      parent: "Anagrafiche"
    },
  
    // Production routes
    {
      match: "/production/archive/",
      title: "Nome della produzione",
      backTo: "/production/archive",
      parent: "Produzioni"
    },
    {
      match: "/production/archive",
      title: "Archivio",
      backTo: "/production",
      parent: "Produzione"
    },
    {
      match: "/production/processes/",
      title: "Nome del processo",
      backTo: "/production/processes",
      parent: "Processi"
    },
    {
      match: "/production/processes",
      title: "Processi",
      backTo: "/production",
      parent: "Produzione"
    },
    {
      match: "/production/list/",
      title: "Nome della produzione",
      backTo: "/production/list",
      parent: "Produzioni"
    },
    {
      match: "/production/list",
      title: "Produzioni",
      backTo: "/production",
      parent: "Produzione"
    },
    {
      match: "/production/plan",
      title: "Pianifica",
      backTo: "/production",
      parent: "Produzione"
    },
  
    // Attività routes
    {
      match: "/attivita/progetti/",
      title: "Nome del progetto",
      backTo: "/attivita/progetti",
      parent: "Progetti"
    },
    {
      match: "/attivita/progetti",
      title: "Progetti",
      backTo: "/attivita",
      parent: "Attività"
    },
    {
      match: "/attivita/calendario",
      title: "Calendario",
      backTo: "/attivita",
      parent: "Attività"
    },
  
    // Ovoland
    {
      match: "/dashboard",
      title: "Ovoland",
      backTo: null,
      parent: null
    },
  
    // Default
    {
      match: "*",
      title: "Titolo della Pagina",
      backTo: null,
      parent: null
    }
  
  ]
  const HeaderBelow = ({ cantine, setCantine, production, setProduction }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
  
    const handleOpenDialog = (value) => {
      setOpen(value);
    };
  
    // Get the current matching route config
    const currentRoute = routeMap.find((route) =>
      location?.pathname === route.match
    );
  
    const handleGoBack = () => {
      if (currentRoute?.backTo) {
        if(currentRoute.match === '/strutture/terreni' || 'strutture/stabilimenti' || '/strutture/prodotti' || '/logistica/mezzi'){
          localStorage.removeItem('cantine_id')
        }
    
          if (currentRoute?.match === '/produzione/vendemmia') {
            dispatch(resetSingleProduzione());
          }
       
        
        navigate(currentRoute?.backTo);
      } else {
        navigate(-1); // Fallback if nothing matches
      }
    };
  
    return (
      <div>
        <Toolbar
          className="titleBlock"
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box className="pageTitle" display="flex" alignItems="center">
            <IconButton edge="start" color="inherit" onClick={handleGoBack}>
             {currentRoute?.title==="Ovoland" ?'':<ArrowBackIcon />}
            </IconButton>
  
            <Typography variant="h2">
              {currentRoute ? currentRoute.title : "Ovoland"}
            </Typography>
          </Box>
  
        
            {!location.pathname.includes("/vendite/preventivi/sub-preventivi") &&
          !location.pathname.includes("/vendite/ordini/sub-ordini") &&
          !location.pathname.includes("/acquisti/preventivi/sub-preventivi") &&
          !location.pathname.includes("/acquisti/budget/sub-budget") &&
          !location.pathname.includes("/dashboard/profitti") &&
          !location.pathname.includes("/dashboard/vendite") &&
          !location.pathname.includes("/dashboard/acquisti") &&
          !location.pathname.includes("/dashboard/personale") &&
          !location.pathname.includes("/dashboard/imposte") &&
          !location.pathname.includes("/dashboard/asset") &&
          !location.pathname.includes("/dashboard/attivita") &&
          !location.pathname.includes("/acquisti/ordini/sub-ordini") &&
          !location.pathname.includes("/amministrazione/documenti/fattura") &&
          !location.pathname.includes("/production/plan") &&
          !location.pathname.includes("/production/list/details") &&
          !location.pathname.includes("/production/processes/details") &&
          !location.pathname.includes("/logistica/sub-DDT") &&
          !location.pathname.includes("/dashboard") &&
          !location.pathname.includes("/strutture/sensori/Location") &&
          !location.pathname.includes("/produzione/vendemmia") &&
          !location.pathname.includes("/produzione/ricette/Fasi") &&
          !location.pathname.includes("/produzione/archivio") &&
          !location.pathname.includes("/logistica/trasporto/graph") && (
            <AddButton
              title="Aggiungi"
              onClick={() => {
                if (location.pathname.includes("/produzione/produzioni")) {
                  setProduction(!production);
                } else {
                  setCantine(!cantine);
                }
              }}
            />

          )}
        </Toolbar>
      </div>
    );
  };
  
  export default HeaderBelow;
  // const handleOpenDialog = (value) => {
  //   setOpen(value);
  // };
  // const location = useLocation();
  // const handleGoBack = () => {
  //   navigate(-1); // Most recommended method
  // };
  // return (
  //   <div>
  //     <Toolbar
  //       className="titleBlock"
  //       sx={{ display: "flex", justifyContent: "space-between" }}
  //     >
  //       <Box className="pageTitle" display="flex" alignItems="center">
  //         <IconButton
  //           edge="start"
  //           color="inherit"
  //           onClick={handleGoBack}
  //         //   window.location.href.includes("/vendite")
  //         //     ? navigate("/vendite/preventivi")
  //         //     : navigate("/dashboard/profitti")
  //         // }
  //         >
  //           <ArrowBackIcon />
  //         </IconButton>

//           {window.location.href.includes("/strutture/cantine") ? (
//             <>
//               {window.location.href.includes("/strutture/cantine/Terreni") || window.location.href.includes("strutture/cantine/Stabilimenti") ||
//                 window.location.href.includes("/strutture/cantine/Prodotti") || window.location.href.includes("/strutture/cantine/Mezzi")


//                 ? <Typography variant="h2">Cantina</Typography> : <Typography variant="h2">Cantine</Typography>}



//             </>) :
//             window.location.href.includes("/strutture/operatori") ? (
//               <>
//                 <Typography variant="h2">Operatori</Typography>
//                 <IconButton
//                   edge="start"
//                   color="inherit"
//                   onClick={() => navigate("/dashboard")}
//                 >
//                 </IconButton>
//               </>
//             )
//               :
//               window.location.href.includes("/produzione/archivio") ? (
//                 <>
//                   <Typography variant="h2">Archivio Produzioni</Typography>
//                   <IconButton
//                     edge="start"
//                     color="inherit"
//                     onClick={() => navigate("/dashboard")}
//                   >
//                     {/* <ArrowForwardIcon /> */}
//                   </IconButton>
//                   {/* <Typography variant="h2">
//                                             Vendemmia 2025
                          
//                                           </Typography> */}
//                 </>
//               ) :
//                 window.location.href.includes("/produzione/trattamenti") ? (
//                   <>
//                     <Typography variant="h2">Trattamenti</Typography>
//                     <IconButton
//                       edge="start"
//                       color="inherit"
//                       onClick={() => navigate("/dashboard")}
//                     >
//                       {/* <ArrowForwardIcon /> */}
//                     </IconButton>
//                     {/* <Typography variant="h2">
//                                 Vendemmia 2025
              
//                               </Typography> */}
//                   </>
//                 ) :
//                   window.location.href.includes("/produzione/ricette/Fasi") ? (
//                     <>
//                       <Typography variant="h2">Ricette</Typography>
//                       <IconButton
//                         edge="start"
//                         color="inherit"
//                         onClick={() => navigate("/dashboard")}
//                       >
//                         {/* <ArrowForwardIcon /> */}
//                       </IconButton>
//                       {/* <Typography variant="h2">
//                     Vendemmia 2025
  
//                   </Typography> */}
//                     </>
//                   ) :
//                     window.location.href.includes("/produzione/vendemmia") ? (
//                       <>
//                         <Typography variant="h2">Produzioni</Typography>
//                         <IconButton
//                           edge="start"
//                           color="inherit"
//                           onClick={() => navigate("/dashboard")}
//                         >
//                           <ArrowForwardIcon />
//                         </IconButton>
//                         <Typography variant="h2">
//                           Vendemmia 2025

//                         </Typography>
//                       </>
//                     ) :
//                       window.location.href.includes("/produzione/produzioni") ? (
//                         <>
//                           <Typography variant="h2">Produzioni</Typography>
//                           <IconButton
//                             edge="start"
//                             color="inherit"
//                             onClick={() => navigate("/dashboard")}
//                           >
//                             {/* <ArrowForwardIcon /> */}
//                           </IconButton>
//                           {/* <Typography variant="h2">
//                                   Nome terreno
                                  
//                                   </Typography> */}
//                         </>
//                       ) :
//                         window.location.href.includes("/strutture/prodotti/") ? (
//                           <>
//                             <Typography variant="h2">Prodotti</Typography>
//                             <IconButton
//                               edge="start"
//                               color="inherit"
//                               onClick={() => navigate("/dashboard")}
//                             >
//                               {/* <ArrowForwardIcon /> */}
//                             </IconButton>
//                             {/* <Typography variant="h2">
//                           Nome terreno
                   
//                         </Typography> */}
//                           </>
//                         ) :
//                           window.location.href.includes("/strutture/sensori/") ? (
//                             <>
//                               <Typography variant="h2">Sensori</Typography>
//                               <IconButton
//                                 edge="start"
//                                 color="inherit"
//                                 onClick={() => navigate("/dashboard")}
//                               >
//                               </IconButton>
//                             </>
//                           ) :
//                             window.location.href.includes("/strutture/sensori") ? (
//                               <>
//                                 <Typography variant="h2">Sensori</Typography>
//                                 <IconButton
//                                   edge="start"
//                                   color="inherit"
//                                   onClick={() => navigate("/dashboard")}
//                                 >
//                                 </IconButton>
//                               </>
//                             ) :



//                             baki hai yaha see




//                               window.location.href.includes("/strutture/prodotti") ? (
//                                 <>
//                                   <Typography variant="h2">Prodotti</Typography>
//                                   <IconButton
//                                     edge="start"
//                                     color="inherit"
//                                     onClick={() => navigate("/dashboard")}
//                                   >
//                                   </IconButton>
//                                 </>
//                               ) :

//                                 window.location.href.includes("/logistica/trasporto") ? (
//                                   <>
//                                     <Typography variant="h2">Trasporti</Typography>
//                                     <IconButton
//                                       edge="start"
//                                       color="inherit"
//                                       onClick={() => navigate("/dashboard")}
//                                     >
//                                     </IconButton>
//                                   </>
//                                 )
//                                   :
//                                   window.location.href.includes("/logistica/mezzi") ? (
//                                     <>
//                                       <Typography variant="h2">Mezzi</Typography>
//                                       <IconButton
//                                         edge="start"
//                                         color="inherit"
//                                         onClick={() => navigate("/dashboard")}
//                                       >
//                                       </IconButton>
//                                     </>
//                                   )
//                                     :
//                                     window.location.href.includes("/logistica/stabilimenti/") ? (
//                                       <>
//                                         <Typography variant="h2">Stabilimenti</Typography>
//                                         <IconButton
//                                           edge="start"
//                                           color="inherit"
//                                           onClick={() => navigate("/dashboard")}
//                                         >
//                                           <ArrowForwardIcon />
//                                         </IconButton>
//                                         <Typography variant="h2">
//                                           Stoccaggio

//                                         </Typography>
//                                       </>
//                                     ) :
//                                       window.location.href.includes("/logistica/stabilimenti") ? (
//                                         <>
//                                           <Typography variant="h2">Stabilimenti</Typography>
//                                           <IconButton
//                                             edge="start"
//                                             color="inherit"
//                                             onClick={() => navigate("/dashboard")}
//                                           >
//                                           </IconButton>
//                                         </>
//                                       )
//                                         :
//                                         window.location.href.includes("/strutture/stabiliment/") ? (
//                                           <>
//                                             <Typography variant="h2">Stabilimenti</Typography>
//                                             <IconButton
//                                               edge="start"
//                                               color="inherit"
//                                               onClick={() => navigate("/dashboard")}
//                                             >
//                                               <ArrowForwardIcon />
//                                             </IconButton>
//                                             <Typography variant="h2">
//                                               Stoccaggio

//                                             </Typography>
//                                           </>
//                                         ) :
//                                           window.location.href.includes("/strutture/stabilimenti") ? (
//                                             <>
//                                               <Typography variant="h2">Stabilimenti</Typography>
//                                               <IconButton
//                                                 edge="start"
//                                                 color="inherit"
//                                                 onClick={() => navigate("/dashboard")}
//                                               >
//                                               </IconButton>
//                                             </>
//                                           ) :
//                                             window.location.href.includes("/strutture/terreni/") ? (
//                                               <>
//                                                 <Typography variant="h2">Terreni</Typography>
//                                                 <IconButton
//                                                   edge="start"
//                                                   color="inherit"
//                                                   onClick={() => navigate("/dashboard")}
//                                                 >
//                                                   <ArrowForwardIcon />
//                                                 </IconButton>
//                                                 <Typography variant="h2">
//                                                   Nome terreno

//                                                 </Typography>
//                                               </>
//                                             ) :
//                                               window.location.href.includes("/strutture/terreni") ? (
//                                                 <>
//                                                   <Typography variant="h2">Terreni</Typography>
//                                                   <IconButton
//                                                     edge="start"
//                                                     color="inherit"
//                                                     onClick={() => navigate("/dashboard")}
//                                                   >
//                                                   </IconButton>
//                                                 </>
//                                               ) :
//                                                 //  previousdata

//                                                 window.location.href.includes("/invoice") ? (
//                                                   <>
//                                                     <Typography variant="h2">Categoria</Typography>
//                                                     <IconButton
//                                                       edge="start"
//                                                       color="inherit"
//                                                       onClick={() => navigate("/dashboard/profitti")}
//                                                     >
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">
//                                                       {" "}
//                                                       {window.location.href.includes("/preventivo")
//                                                         ? "Preventivo"
//                                                         : "Fattura"}{" "}
//                                                     </Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/gantt") ? (
//                                                   <>
//                                                     <Typography variant="h2">Attività </Typography>
//                                                     <IconButton
//                                                       edge="start"
//                                                       color="inherit"
//                                                       onClick={() => navigate("/dashboard/profitti")}
//                                                     >
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Timesheet</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/gantt/library") ? (
//                                                   <>
//                                                     <Typography variant="h2">Attività </Typography>
//                                                     <IconButton
//                                                       edge="start"
//                                                       color="inherit"
//                                                       onClick={() => navigate("/dashboard/profitti")}
//                                                     >
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Timesheet</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/calendario") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite </Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Calendario</Typography>
//                                                     <IconButton edge="start" color="inherit"></IconButton>
//                                                   </>
//                                                 ) : window.location.href.includes(
//                                                   "/vendite/preventivi/sub-preventivi"
//                                                 ) ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Preventivi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del preventivo</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/preventivi") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite </Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Preventivi</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/ordini/sub-ordini") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Ordini</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Numero dell'Ordine</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/ordini") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Ordini</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/budget/") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Preventivi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del budget</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/budget") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Budget</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/lead") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Lead</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/vendite/sub-lead/") ? (
//                                                   <>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Lead</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del lead</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/fornitori/") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Fornitiori</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del Fornitore</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/fornitori") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti </Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Fornitiori</Typography>
//                                                     <IconButton edge="start" color="inherit"></IconButton>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/calendario") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti </Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Calendario</Typography>
//                                                     <IconButton edge="start" color="inherit"></IconButton>
//                                                   </>
//                                                 ) : window.location.href.includes(
//                                                   "/acquisti/preventivi/sub-preventivi"
//                                                 ) ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Preventivi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del preventivo</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/preventivi") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti </Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Preventivi</Typography>
//                                                     <IconButton edge="start" color="inherit"></IconButton>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/ordini/sub-ordini") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Ordini</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Numero dell'Ordine</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/ordini") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Ordini</Typography>
//                                                     <IconButton edge="start" color="inherit"></IconButton>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/budget/sub-budget") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Budget</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del budget</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/acquisti/budget") ? (
//                                                   <>
//                                                     <Typography variant="h2">Acquisti</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Budget</Typography>
//                                                     <IconButton edge="start" color="inherit"></IconButton>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/profitti") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Profitti</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/acquisti") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Acquisti</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/asset") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Asset</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/imposte") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Imposte</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/produzione") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Produzione</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/vendite") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Vendite</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/personale") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Personale</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/dashboard/attivita") ? (
//                                                   <>
//                                                     <Typography variant="h2">Ovoland</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Attivita</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/cataloghi/servizi/") ? (
//                                                   <>
//                                                     <Typography variant="h2">Cataloghi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Servizi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del servizio</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/cataloghi/servizi") ? (
//                                                   <>
//                                                     <Typography variant="h2">Cataloghi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Servizi</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/cataloghi/prodotti/") ? (
//                                                   <>
//                                                     <Typography variant="h2">Cataloghi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Prodotti</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del prodotto</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/cataloghi/prodotti") ? (
//                                                   <>
//                                                     <Typography variant="h2">Cataloghi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Prodotti</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/cataloghi/configuratore/") ? (
//                                                   <>
//                                                     <Typography variant="h2">Cataloghi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Configuratore</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/cataloghi/listini/") ? (
//                                                   <>
//                                                     <Typography variant="h2">Cataloghi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Listini</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Nome del listino</Typography>
//                                                   </>
//                                                 ) : window.location.href.includes("/cataloghi/listini") ? (
//                                                   <>
//                                                     <Typography variant="h2">Cataloghi</Typography>
//                                                     <IconButton edge="start" color="inherit">
//                                                       <ArrowForwardIcon />
//                                                     </IconButton>
//                                                     <Typography variant="h2">Listini</Typography>
//                                                   </>
//                                                 ) : // Hr section
//                                                   window.location.href.includes("/hr/sub-colaboratory/") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Collaboratori</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Nome del collaboratore</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/colaboratory") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Collaboratori</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/Calendario") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Turni</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/organizza/") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Nome del turno</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/Organizza") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Turni</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/ferie-e-permisse/evento") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Eventi</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Nome evento</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/ferie-e-permisse") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Eventi</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/buste-page/busta") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Busta paga</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Nome della busta paga</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/buste-page") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Busta paga</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/candidati/candidato/") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Candidati</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Candidato</Typography>
//                                                     </>
//                                                   ) : window.location.href.includes("/hr/candidati") ? (
//                                                     <>
//                                                       <Typography variant="h2">HR</Typography>
//                                                       <IconButton edge="start" color="inherit">
//                                                         <ArrowForwardIcon />
//                                                       </IconButton>
//                                                       <Typography variant="h2">Candidati</Typography>
//                                                     </>
//                                                   ) : // amministrazione part start
//                                                     window.location.href.includes("/amministrazione/imposte/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Imposte</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome dell’imposta</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/imposte") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Imposte</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/documenti/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Documenti</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Fattura</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/documenti") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Documenti</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/bilancio") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Bilancio</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/scadenzario") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Scadenzario</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/asset/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Asset</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome asset</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/asset") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Asset</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes(
//                                                       "/amministrazione/flussi-di-cassa"
//                                                     ) ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Flusso di cassa</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/registri-iva") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Registri IVA</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/amministrazione/prima-nota") ? (
//                                                       <>
//                                                         <Typography variant="h2">Amministrazione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Prima nota</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/prenota") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Prenota</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/stabilimenti/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Stabilimenti</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome stabilimento</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/stabilimenti") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Stabilimenti</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/mezzi/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Mezzi</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del mezzo</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/mezzi") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Mezzi</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/mezzi/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Mezzi</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del mezzo</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/mezzi") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Mezzi</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/attrezzature/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Attrezzature</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome dell’attrezzatura</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/attrezzature") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Attrezzature</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/giacenze/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Giacenze</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome della giacenza</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/giacenze") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Giacenze</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/sub-DDT") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">DTT</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Numero del DDT</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/logistica/DDT") ? (
//                                                       <>
//                                                         <Typography variant="h2">Logistica</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">DTT</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/anagrafiche/sub-lead/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Lead</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del lead</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/lead") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Lead</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/prodotti") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Prodotti</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/attrezzature") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Attrezzature</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/mezzi") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Mezzi</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/sensori") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Sensori</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/stabilimenti") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Stabilimenti</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/lotti") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Lotti</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/clienti/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Clienti</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del cliente</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/clienti") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Clienti</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/fornitori/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Fornitori</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del Fornitore</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/fornitori") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Fornitori</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/sub-colaboratory/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Collaboratori</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del collaboratore</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/colaboratory") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Collaboratori</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/candidati/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Collaboratori</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del collaboratore</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/angrafiche/candidati") ? (
//                                                       <>
//                                                         <Typography variant="h2">Anagrafiche</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Collaboratori</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/production/archive/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Produzione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Produzioni</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome della produzione</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/production/archive") ? (
//                                                       <>
//                                                         <Typography variant="h2">Produzione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Archivio</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/production/processes/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Produzione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Processi</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del processo</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/production/processes") ? (
//                                                       <>
//                                                         <Typography variant="h2">Produzione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Processi</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/production/list/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Produzione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Produzioni</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome della produzione</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/production/list") ? (
//                                                       <>
//                                                         <Typography variant="h2">Produzione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Produzioni</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/production/plan") ? (
//                                                       <>
//                                                         <Typography variant="h2">Produzione</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Pianifica</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/attivita/progetti/") ? (
//                                                       <>
//                                                         <Typography variant="h2">Attività</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Progetti</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Nome del progetto</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/attivita/progetti") ? (
//                                                       <>
//                                                         <Typography variant="h2">Attività</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Progetti</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/attivita/calendario") ? (
//                                                       <>
//                                                         <Typography variant="h2">Attività</Typography>
//                                                         <IconButton edge="start" color="inherit">
//                                                           <ArrowForwardIcon />
//                                                         </IconButton>
//                                                         <Typography variant="h2">Calendario</Typography>
//                                                       </>
//                                                     ) : window.location.href.includes("/dashboard") ? (
//                                                       <>
//                                                         <Typography variant="h2">Ovoland</Typography>
//                                                       </>
//                                                     ) : (
//                                                       <Typography variant="h2">Titolo della Pagina</Typography>
//                                                     )}
// //         </Box>
        // {!location.pathname.includes("/vendite/preventivi/sub-preventivi") &&
        //   !location.pathname.includes("/vendite/ordini/sub-ordini") &&
        //   !location.pathname.includes("/acquisti/preventivi/sub-preventivi") &&
        //   !location.pathname.includes("/acquisti/budget/sub-budget") &&
        //   !location.pathname.includes("/dashboard/profitti") &&
        //   !location.pathname.includes("/dashboard/vendite") &&
        //   !location.pathname.includes("/dashboard/acquisti") &&
        //   !location.pathname.includes("/dashboard/personale") &&
        //   !location.pathname.includes("/dashboard/imposte") &&
        //   !location.pathname.includes("/dashboard/asset") &&
        //   !location.pathname.includes("/dashboard/attivita") &&
        //   !location.pathname.includes("/acquisti/ordini/sub-ordini") &&
        //   !location.pathname.includes("/amministrazione/documenti/fattura") &&
        //   !location.pathname.includes("/production/plan") &&
        //   !location.pathname.includes("/production/list/details") &&
        //   !location.pathname.includes("/production/processes/details") &&
        //   !location.pathname.includes("/logistica/sub-DDT") &&
        //   !location.pathname.includes("/dashboard") &&
        //   !location.pathname.includes("/strutture/sensori/Location") &&
        //   !location.pathname.includes("/produzione/vendemmia") &&
        //   !location.pathname.includes("/produzione/ricette/Fasi") &&
        //   !location.pathname.includes("/produzione/archivio") &&
        //   !location.pathname.includes("/logistica/trasporto/graph") && (
        //     <AddButton
        //       title="Aggiungi"
        //       onClick={() => {
        //         if (location.pathname.includes("/produzione/produzioni")) {
        //           setProduction(!production);
        //         } else {
        //           setCantine(!cantine);
        //         }
        //       }}
        //     />

        //   )}

//         {/* {open && <AddDocument onClose={handleOpenDialog} open={open} />} */}
//       </Toolbar>
//     </div>
//   );
// };
// export default HeaderBelow;
